<div style="padding:20px;">
    <div *ngIf="opmPartners && opmPartners.length > 0">
        <p-select style="margin:5px 21px" ngDefaultControl placeholder="Partner" [options]="opmPartnersOptions" [(ngModel)]="partnerId" optionLabel="name"
        optionValue="id" (onChange)="getNewView()"/>
  
    </div>
    <app-view [items]="view?.data?.content" [data]="data?.data" *ngIf="view && view?.data" [info]="info" ></app-view>
</div>
<div style="text-align:center;">
</div>

